import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {
  CURRENCY,
  CURRENCY_CRYPTO_NAME,
  CURRENCY_NAME,
  GOLD_QUANTITY_LIST,
  I_POP_OVER,
  PRODUCT_BULLION_TYPE,
  PRODUCT_GOLD_TYPE,
  SELECT_BOX_THEME,
  SUBSCRIPTION_MODULE_TYPE,
  SUPPORTED_PAYMENT_METHOD,
  SUPPORTED_PAYMENT_METHOD_NAME,
} from "../../constants";
import { useLocation, useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";
import Currency from "../../components/currency";
import {
  saveManualDetails,
  createStripeTokenAction,
  extraFeeCalcAction,
  setBankTranferBackTrigger,
  currencyConversionCalcHighAction,
  setCurrencyWatch,
  payWithCryptoAction,
  setTripleaUrl,
  selectedCardFunc,
  setPaymentSteps,
  setQuantity,
  createManualEntryAction,
  setOpenCartPage,
  subscriptionPlan,
} from "../../actions/stripe";
import InfoModalStatic from "../dashboard/infoModalStatic";
import toast from "react-hot-toast";
import PayWithCryptoPopup from "./PayWithCryptoPopup";
import ProductQuantity from "../../components/buyProduct/ProductQuantity";
import SelectPayment from "../../components/buyProduct/SelectPayment";
import PayWithCard from "../../components/buyProduct/PayWithCard";
import PaymentStatus from "../../components/buyProduct/PaymentStatus";
import BankDetail from "./BankDetail";
import BreadcrumbsPayment from "../../components/header/breadcrumbsPayment";
import PaymentSteps from "./PaymentSteps";
import {
  userBidGoldPriceLockAction,
  userBidSilverPriceLockAction,
} from "../../actions/user";
import CopyToClipboard from "react-copy-to-clipboard";

export default function BankTransfer() {
  const dispatch = useDispatch();
  const {
    control,
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      saveInfo: "true",
    },
  });
  const [loader, setLoader] = useState(false);

  const {
    stripePlans,
    paymentMethodSelection,
    stripeType,
    savedbankInfoDetails,
    isOverrideProduct,
    stripeSubscription,
    cartAmount,
    forceCartAmount,
    triggerBankTransferBack,
    selectedQuantity,
    isManualPayment,
    selectedStep,
    selectedCard,
    isTripleaUrl,
    isManualPaymentType,
  } = useSelector((state) => state.stripe);
  const { bidGoldHeader, bidSilverHeader } = useSelector((state) => state.user);

  const { planLoader } = useSelector((state) => state.subscriptionPlanProducts);
  const { bankTransferDetail } = useSelector((state) => state.settings);
  const location = useLocation();
  const pathnames = location?.pathname?.split("/").filter((x) => x);
  const planId = pathnames?.[pathnames.length - 2];
  const { selectedCompany } = useSelector((state) => state.company);
  const currencyWatch = watch("currency");
  const saveInfoWatch = watch("saveInfo");
  const amountWatch = watch("amount");
  const cryptoAmountWatch = watch("cryptoAmount");

  const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
  const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);

  const handleClickInfo = (type) => {
    setInfoModalStaticShow(true);
    setInfoModalStaticShowType(type);
  };

  const navigate = useNavigate();
  useEffect(() => {
    register("baseAmountRate", { required: true });
    register("transactionFee", { required: false });
    register("amount", { required: true });
    register("cryptoAmount", { required: false });
  }, []);

  const calcExtraFeeCharges = () => {
    const payload = {
      price: stripePlans?.price,
      quantity: selectedQuantity.value,
      paymentMethodSelection: parseInt(paymentMethodSelection),
      goldType: stripePlans?.goldProductType?.value,
    };
    dispatch(
      extraFeeCalcAction(
        payload?.paymentMethodSelection,
        parseInt(stripeType),
        payload
      )
    );
  };

  useEffect(() => {
    const checkIfSubscriptionDetailsAvailable = () => {
      if (stripePlans && Object.keys(stripePlans).length === 0) {
        if (pathnames[1] == "payment") {
          navigate(RoutesPaths.PAYMENT);
        } else if (pathnames[1] == "dashboard") {
          navigate(RoutesPaths.DASHBOARD_PRODUCT_PAGE.replace(":slug", planId));
        } else if (pathnames[1] == "book-of-business") {
          navigate(
            RoutesPaths.BOOK_OF_BUSINESS_PRODUCT_PAGE.replace(":slug", planId)
          );
        } else if (pathnames[1] == "home") {
          navigate(RoutesPaths.HOME_PRODUCT_PAGE.replace(":slug", planId));
        } else if (pathnames[1] == "pay") {
          navigate(
            RoutesPaths.MESSAGE_DETAIL + "?room=" + location?.state?.sid || ""
          );
        } else {
          navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", planId));
        }
      } else {
        if (!triggerBankTransferBack) {
          if (stripePlans?.price) {
            calcExtraFeeCharges();
          }
        }
      }
    };
    checkIfSubscriptionDetailsAvailable();
  }, [stripePlans, selectedQuantity, dispatch, selectedStep]);

  const onSubmit = async (data) => {
    if (data?.amount > 0) {
      setLoader(true);
      let additionalPayload = {
        subscriptionModuleType: parseInt(stripeType),
        paymentMethodSelection: paymentMethodSelection,
        planId:
          (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
            ? stripePlans?._id
            : stripePlans?.id) || null,
        company: selectedCompany?.id,
        baseRequestCurrency: stripePlans?.currency?.value || null,
      };
      if (
        additionalPayload.subscriptionModuleType ===
        SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
      ) {
        additionalPayload.capital = stripePlans?.capital?.id || null;
        additionalPayload.baseRequestShareType =
          stripePlans?.capital?.shareType || null;
      }
      const payload = { ...data, ...additionalPayload };
      if (paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) {
        handleProceed();
      } else if (
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
      ) {
        await dispatch(saveManualDetails(payload));
        handleCryptoProceed();
      } else {
        await dispatch(saveManualDetails(payload));
        await handleCompleteForm(payload);
      }
    } else {
      toast.error("Amount must be greater than 0");
    }
  };

  const handleCompleteForm = async (payload) => {
    try {
      const resp = await dispatch(createManualEntryAction(payload));
      if (resp?.status) {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      } else {
        setLoader(false);
      }
    } catch (error) { }
    setLoader(false);
  };

  useEffect(() => {
    if (savedbankInfoDetails && Object.keys(savedbankInfoDetails).length > 0) {
      setValue(
        "quantity",
        savedbankInfoDetails.quantity ?? GOLD_QUANTITY_LIST[0]
      );
      setValue(
        "currency",
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
          ? { value: "sgd", label: "Singapore Dollar (SGD)" }
          : savedbankInfoDetails?.currency
      );
      setValue("sendingInstruction", savedbankInfoDetails?.sendingInstruction);
      setValue("number", savedbankInfoDetails.number);
      setValue("nickName", savedbankInfoDetails.nickName);
    }
  }, [setValue, savedbankInfoDetails]);

  useEffect(() => {
    calculateCartForceAction();
  }, [cartAmount, isManualPayment]);

  const calculateCartForceAction = (fromForce = null) => {
    const payload = {
      baseReqCurrency: stripePlans?.currency?.value,
      from: fromForce ? fromForce : stripePlans?.currency?.value,
      to: currencyWatch?.value,
      price:
        parseFloat(isManualPayment) > 0
          ? isManualPayment
          : isManualPaymentType &&
            parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
            ? isManualPayment
            : stripePlans?.price,
      paymentMethodSelection: parseInt(paymentMethodSelection),
      moduleType: parseInt(stripeType),
      quantity: selectedQuantity.value,
      isManual: parseFloat(isManualPayment) > 0 ? true : false,
      goldType: stripePlans?.goldProductType?.value,
    };
    if (parseFloat(isManualPayment) > 0) {
      setValue("cryptoAmount", isManualPayment);
    } else {
      setValue("cryptoAmount", stripePlans?.price);
    }
    dispatch(currencyConversionCalcHighAction(payload));
  };

  useEffect(() => {
    if (
      stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM &&
      [CURRENCY.INR, CURRENCY.CNY].includes(currencyWatch?.value)
    ) {
      dispatch(setQuantity(GOLD_QUANTITY_LIST[0]));
    }
    calculateCartForceAction();
  }, [currencyWatch]);

  useEffect(() => {
    dispatch(setBankTranferBackTrigger(false));
    if (!triggerBankTransferBack) {
      calcExtraFeeCharges();
    }
  }, [selectedQuantity, triggerBankTransferBack]);

  useEffect(() => {
    setValue("baseAmountRate", forceCartAmount?.baseAmountRate);
    setValue("transactionFee", forceCartAmount?.transactionFees);
    setValue("amount", forceCartAmount?.payableAmount);
    if (
      paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO &&
      (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PLAN ||
        parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PRODUCT ||
        parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB)
    ) {
      setValue("cryptoAmount", stripePlans?.price);
    }
  }, [forceCartAmount]);

  // Define a variable to hold the validation rules based on the condition
  let validationRules = {
    required: {
      value: true,
      message:
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
          ? "Enter your account number"
          : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
            ? "Enter you wallet address"
            : "",
    },
  };

  if (
    [
      SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER,
      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO,
    ].includes(paymentMethodSelection)
  ) {
    validationRules.pattern = {
      value: /^[a-zA-Z0-9]+$/,
      message: "Please enter only alphanumeric value",
    };
  }

  const handleProceed = async () => {
    if (amountWatch && stripeSubscription && selectedCompany.id) {
      let payload = {
        companyId: selectedCompany.id,
        planId:
          parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
            ? stripeSubscription._id
            : stripeSubscription.id,
        subscriptionModuleType: parseInt(stripeType),
        paymentMethodSelection: paymentMethodSelection,
        quantity: selectedQuantity,
        currency: currencyWatch,
        baseAmountRate: parseFloat(forceCartAmount?.baseAmountRate),
        baseRequestCurrency: stripeSubscription?.currency?.value || null,
        transactionFee: parseFloat(forceCartAmount?.transactionFees),
        amount: parseFloat(amountWatch),
        cardId: selectedCard?.id,
      };
      if (
        payload.subscriptionModuleType ===
        SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
      ) {
        payload.baseRequestShareType = stripeSubscription?.capital?.shareType;
        payload.capital = stripeSubscription?.capital?.id;
        payload.loadStripeData = {
          currency: stripeSubscription?.currency?.value,
          amount: parseFloat(amountWatch),
        };
      }
      if (payload.planId || Object.keys(payload.loadStripeData).length > 0) {
        const resp = await dispatch(createStripeTokenAction(payload));
        setLoader(false);
      } else {
        setLoader(false);
      }
    } else {
      toast.error("Could not able to proceed, please contact administrator.");
      setLoader(false);
    }
  };

  const handleCryptoProceed = async () => {
    if (amountWatch && stripeType && selectedCompany.id) {
      let payload = {
        company: selectedCompany.id,
        planId:
          (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
            ? stripePlans?._id
            : stripePlans?.id) || null,
        subscriptionModuleType: parseInt(stripeType),
        paymentMethodSelection: paymentMethodSelection,
        quantity: selectedQuantity,
        currency: currencyWatch,
        baseAmountRate: parseFloat(cryptoAmountWatch)
          ? parseFloat(cryptoAmountWatch) * parseFloat(selectedQuantity?.value)
          : parseFloat(amountWatch),
        baseRequestCurrency: stripePlans?.currency?.value || null,
        amount: parseFloat(amountWatch),
      };
      if (
        payload.subscriptionModuleType ===
        SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
      ) {
        payload.baseRequestShareType = stripePlans?.capital?.shareType;
        payload.capital = stripePlans?.capital?.id;
      }
      var resp = await dispatch(payWithCryptoAction(payload));
      setLoader(false);
      if (resp.status) {
        if (resp?.data?.hosted_url) {
          dispatch(setTripleaUrl(resp?.data?.hosted_url, true));
        }
      } else {
        toast.error(
          resp?.data?.message
            ? "Something wen't wrong"
            : resp?.data
              ? resp?.data
              : "Something wen't wrong"
        );
      }
    } else {
      toast.error("Could not able to proceed, please contact administrator.");
      setLoader(false);
    }
  };

  useEffect(() => {
    dispatch(
      setCurrencyWatch(currencyWatch && currencyWatch?.value?.toUpperCase())
    );
  }, [currencyWatch]);

  const [isTransactionVisible, setTransactionVisible] = useState(true);

  const toggleTransactionVisibility = () => {
    setTransactionVisible(!isTransactionVisible);
  };

  const [isTransactionVisibleOnce, setTransactionVisibleOnce] = useState(true);
  const toggleTransactionInsOnce = () => {
    setTransactionVisibleOnce(!isTransactionVisibleOnce);
  };

  const [isTransactionVisibleTwo, setTransactionVisibleTwo] = useState(true);
  const toggleTransactionInsTwo = () => {
    setTransactionVisibleTwo(!isTransactionVisibleTwo);
  };

  const handleToggle = (value) => {
    setValue("saveInfo", value.target.checked);
    trigger("saveInfo");
  };

  const handleStep = (value) => {
    let stepValue = selectedStep - value;
    if (stepValue >= 1) {
      dispatch(setPaymentSteps(stepValue));
      dispatch(setOpenCartPage(false));
    }
    if (stepValue == 0) {
      if (pathnames[1] == "payment") {
        navigate(RoutesPaths.PAIDUPDETAILPAYMENT.replace(":slug", planId));
      } else if (pathnames[1] == "dashboard") {
        navigate(RoutesPaths.DASHBOARD_PRODUCT_PAGE.replace(":slug", planId));
      } else if (pathnames[1] == "book-of-business") {
        navigate(
          RoutesPaths.BOOK_OF_BUSINESS_PRODUCT_PAGE.replace(":slug", planId)
        );
      } else if (pathnames[1] == "home") {
        navigate(RoutesPaths.HOME_PRODUCT_PAGE.replace(":slug", planId));
      } else if (pathnames[1] == "pay") {
        navigate(RoutesPaths.MESSAGE_DETAIL + "?room=" + location?.state?.sid);
      } else if (pathnames[1] === "share-paid-up-capital") {
        navigate(RoutesPaths.PAY_PAIDUP_PAGE.replace(":slug", planId));
      } else {
        navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", planId));
      }
    }
  };

  const forwardPaymentPage = async (item) => {
    const stripePlanId = stripePlans?.id || stripePlans?._id;
    let checkGoldProduct = null;
    for (const property in bidGoldHeader) {
      if (bidGoldHeader[property].id === stripePlanId)
        checkGoldProduct = property;
    }
    let checkSilverProduct = null;
    for (const property in bidSilverHeader) {
      if (bidSilverHeader[property].id === stripePlanId)
        checkSilverProduct = property;
    }

    if (checkGoldProduct || checkSilverProduct) {
      if (
        stripePlans?.productBullionType?.value === PRODUCT_BULLION_TYPE.GOLD
      ) {
        await dispatch(
          userBidGoldPriceLockAction(item, {
            type: checkGoldProduct,
            price: stripePlans?.price,
          })
        );
      } else {
        await dispatch(
          userBidSilverPriceLockAction(item, {
            type: checkSilverProduct,
            price: stripePlans?.price,
          })
        );
      }
    }
    if (
      item === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
      item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
    ) {
      dispatch(setPaymentSteps(3));
      dispatch(selectedCardFunc(null));
    } else if (item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) {
      dispatch(subscriptionPlan(stripePlans));
      dispatch(setPaymentSteps(3));
    } else {
      // setFailedMessage('Please select a valid payment method');
    }
    dispatch(setOpenCartPage(false));
  };

  return (
    <>
      {selectedStep !== 4 && (
        <div className="desktop-breadcrumb-header">
          <BreadcrumbsPayment
            selectedStep={selectedStep}
            handleStep={handleStep}
            mobileHeader={
              selectedStep === 1
                ? stripePlans?.planType?.value ===
                  SUBSCRIPTION_MODULE_TYPE.FUNDS ||
                  stripePlans?.planType?.value ===
                  SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS
                  ? "Add funds"
                  : stripePlans?.planType?.value ===
                    SUBSCRIPTION_MODULE_TYPE.CUSTOM
                    ? "Select amount"
                    : "Select Quantity"
                : selectedStep === 2
                  ? "Select Payment Method"
                  : paymentMethodSelection ===
                    SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                    paymentMethodSelection ===
                    SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                    ? SUPPORTED_PAYMENT_METHOD_NAME[paymentMethodSelection]
                    : paymentMethodSelection ===
                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                      ? `Crypto transfer`
                      : "-"
            }
            loader={planLoader}
          />
        </div>
      )}
      <div className="container-fluid">
        <PaymentSteps selectedStep={selectedStep} />
      </div>
      <div className="container bankPage inner-container-fluid">
        <div className="row buyProductSection">
          <div className="col-md-8">
            <form>
              {selectedStep === 1 && <ProductQuantity />}
              {selectedStep === 2 && (
                <SelectPayment forwardPaymentPage={forwardPaymentPage} />
              )}
              {selectedStep === 3 && (
                <div className="container">
                  <div className="row buyProductSectionBg">
                    <div className="col-md-12">
                      <div className="userDetail">
                        {paymentMethodSelection ===
                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD && (
                            <PayWithCard />
                          )}
                        {(paymentMethodSelection ===
                          SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                          paymentMethodSelection ===
                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) && (
                            <p className="header">
                              {paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                ? "I will be sending the wire from the following bank/institution"
                                : paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                  ? `I will be paying by card in the following currency`
                                  : "-"}
                            </p>
                          )}
                        <div className="innerDetail">
                          <div className="row">
                            {!isTripleaUrl && (
                              <div className="col-md-12 mb-3">
                                <div className="inputHolder inputHolderColumn m-0">
                                  <label className="label">
                                    Select{" "}
                                    {paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                                      paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                      ? "currency"
                                      : paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? "token"
                                        : ""}
                                  </label>
                                  <Controller
                                    name="currency"
                                    rules={{ required: true }}
                                    control={control}
                                    // defaultValue={null}
                                    render={({ field }) => (
                                      <Select
                                        theme={SELECT_BOX_THEME}
                                        className="select-border bankTransferSelectField customBankTransferField"
                                        {...field}
                                        options={
                                          paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                                            paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                            ? CURRENCY_NAME
                                            : paymentMethodSelection ===
                                              SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                              ? CURRENCY_CRYPTO_NAME
                                              : []
                                        }
                                        getOptionLabel={(option) => (
                                          <div className="selectLabelContent">
                                            <img
                                              src={`assets/img/${option.value}.png`}
                                              alt={option.value}
                                              style={{
                                                marginRight: 10,
                                                width: 20,
                                                height: 20,
                                              }}
                                            />
                                            {option.value.toUpperCase()}
                                          </div>
                                        )}
                                        getOptionValue={(option) =>
                                          option.value
                                        }
                                        isClearable={false}
                                        placeholder="Select currency"
                                      />
                                    )}
                                  />
                                </div>

                                {errors.currency?.type === "required" && (
                                  <span className="errorMessage ">
                                    Select your{" "}
                                    {paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                      ? "currency"
                                      : paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? "token"
                                        : ""}
                                  </span>
                                )}
                              </div>
                            )}

                            {paymentMethodSelection ===
                              SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER && (
                                <>
                                  {/* <div className="col-md-6 mb-3">
                                  <div className="inputHolder inputHolderColumn m-0">
                                    <label className="label">
                                      Sending institution
                                    </label>
                                    <input
                                      maxLength={50}
                                      type="div"
                                      className="form-control bankTransferField"
                                      {...register("sendingInstruction", {
                                        required: true,
                                      })}
                                    />
                                  </div>
                                  {errors.sendingInstruction?.type ===
                                    "required" && (
                                    <span className="errorMessage ">
                                      Enter your sending institution
                                    </span>
                                  )}
                                </div>

                                <div className="col-md-6 mb-3">
                                  <div className="inputHolder inputHolderColumn m-0">
                                    <label className="label">
                                      Account number
                                    </label>
                                    <input
                                      maxLength={50}
                                      type="div"
                                      className="form-control bankTransferField"
                                      {...register("number", validationRules)}
                                    />
                                  </div>

                                  {errors && errors.number && (
                                    <span className="errorMessage ">
                                      {errors?.number?.message}
                                    </span>
                                  )}
                           
                                </div>

                                <div className="col-md-12 mb-3">
                                  <div className="inputHolder inputHolderColumn m-0">
                                    <label className="label">
                                      Account name
                                    </label>
                                    <input
                                      maxLength={40}
                                      type="div"
                                      className="form-control bankTransferField"
                                      {...register("nickName", {
                                        required: true,
                                      })}
                                    />
                                  </div>
                                  {errors.nickName?.type === "required" && (
                                    <span className="errorMessage ">
                                      Enter your account name
                                    </span>
                                  )}
                                </div>
                                <div className="col-md-6 mb-3">
                                  <div className="checkBoxSaveBank">
                                    <input
                                      type="checkbox"
                                      className="customCheckbox"
                                      checked={saveInfoWatch}
                                      onChange={handleToggle}
                                      id="saveInfoToggle"
                                    />
                                    <label
                                      htmlFor="saveInfoToggle"
                                      className="m-0"
                                    >
                                      Save bank info
                                    </label>
                                  </div>
                                </div>
                                <BankDetail
                                  toggleTransactionVisibility={
                                    toggleTransactionVisibility
                                  }
                                  isTransactionVisible={isTransactionVisible}
                                  bankTransferDetail={bankTransferDetail}
                                /> */}
                                  {/* Transfer instructions 1 */}
                                  <div className="col-md-12">
                                    <div
                                      className="transferInstructionHeader"
                                      onClick={toggleTransactionInsOnce}
                                    >
                                      <div className="transferInstruction">
                                        <img
                                          src="assets/img/transferInfo.svg"
                                          alt="info"
                                        />
                                        <p className="m-0">
                                          Transfer instructions 1
                                        </p>
                                      </div>
                                      <div style={{ cursor: "pointer" }}>
                                        {isTransactionVisibleOnce ? (
                                          <img
                                            src="assets/img/arrowUp.svg"
                                            alt="Icon"
                                          />
                                        ) : (
                                          <img
                                            src="assets/img/arrowDown.svg"
                                            alt="Icon"
                                          />
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className={`userDetailsTransaction ${isTransactionVisibleOnce ? "" : "hidden"
                                        }`}
                                    >
                                      <div
                                        className="transactionSectionOnce"
                                        style={{ paddingLeft: "18px" }}
                                      >
                                        <div className="accountholderDetailsCopy">
                                          <div className="accountholderDetails">
                                            <h5 className="m-0">Step 1:</h5>
                                            <p className="m-0">
                                              Login to your banking app and select
                                              PayNow as the transfer method.
                                            </p>
                                          </div>
                                        </div>
                                        <hr
                                          className="dootedHr"
                                          style={{
                                            marginTop: "12px",
                                            marginBottom: "12px",
                                          }}
                                        />
                                        <div className="accountholderDetailsCopy">
                                          <div className="accountholderDetails">
                                            <h5 className="m-0">Step 2:</h5>
                                            <p className="m-0">
                                              Choose the VPA option and enter this
                                              code:<span> **UEN201602269CA00#XNAP**</span>
                                            </p>
                                          </div>
                                        </div>
                                        <hr
                                          className="dootedHr"
                                          style={{
                                            marginTop: "12px",
                                            marginBottom: "12px",
                                          }}
                                        />
                                        <div className="accountholderDetailsCopy">
                                          <div className="accountholderDetails">
                                            <h5 className="m-0">Step 3:</h5>
                                            <p className="m-0">
                                              ***Important:*** Enter your name in
                                              the comments field. If not, your
                                              name will not be shown to the
                                              recipient.
                                            </p>
                                          </div>
                                        </div>
                                        <hr
                                          className="dootedHr"
                                          style={{
                                            marginTop: "12px",
                                            marginBottom: "12px",
                                          }}
                                        />
                                        <div className="accountholderDetailsCopy">
                                          <div className="accountholderDetails">
                                            <h5 className="m-0">Step 4:</h5>
                                            <p className="m-0">
                                              Double check the recipient name
                                              displayed, enter the amount and
                                              confirm the transfer.
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Transfer instructions 2 */}
                                  <div className="col-md-12">
                                    <div
                                      className="transferInstructionHeader"
                                      onClick={toggleTransactionInsTwo}
                                    >
                                      <div className="transferInstruction">
                                        <img
                                          src="assets/img/transferInfo.svg"
                                          alt="info"
                                        />
                                        <p className="m-0">
                                          Transfer instructions 2
                                        </p>
                                      </div>
                                      <div style={{ cursor: "pointer" }}>
                                        {isTransactionVisibleTwo ? (
                                          <img
                                            src="assets/img/arrowUp.svg"
                                            alt="Icon"
                                          />
                                        ) : (
                                          <img
                                            src="assets/img/arrowDown.svg"
                                            alt="Icon"
                                          />
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      className={`userDetailsTransaction ${isTransactionVisibleTwo ? "" : "hidden"
                                        }`}
                                    >
                                      <div
                                        className="transactionSectionOnce"
                                        style={{ paddingLeft: "18px" }}
                                      >
                                        <div className="accountholderDetailsCopy">
                                          <div className="accountholderDetails">
                                            <h5 className="m-0">Step 1:</h5>
                                            <p className="m-0">
                                              Login to your banking app and
                                              scan/upload the QR code.
                                            </p>
                                          </div>
                                        </div>
                                        <hr
                                          className="dootedHr"
                                          style={{
                                            marginTop: "12px",
                                            marginBottom: "12px",
                                          }}
                                        />
                                        <div className="accountholderDetailsCopy">
                                          <div className="accountholderDetails">
                                            <h5 className="m-0">Step 2:</h5>
                                            <p className="m-0">
                                              Important: Enter your name in the
                                              comments field. If not, your name
                                              will not be shown to the recipient.
                                            </p>
                                          </div>
                                        </div>
                                        <hr
                                          className="dootedHr"
                                          style={{
                                            marginTop: "12px",
                                            marginBottom: "12px",
                                          }}
                                        />
                                        <div className="payNowImageOuter">
                                          <img
                                            src="assets/img/payQRCode.png"
                                            alt="QRCode"
                                            className="payNowImage"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            {paymentMethodSelection ===
                              SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO &&
                              isTripleaUrl && (
                                <PayWithCryptoPopup url={isTripleaUrl} />
                              )}
                          </div>
                        </div>

                        <div style={{ marginTop: 12 }}>
                          <div>
                            <p className="header">
                              I will be sending the following{" "}
                              {paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                ? "estimated"
                                : ""}{" "}
                              amount
                            </p>
                          </div>

                          <div className="followingSection">
                            <div className="followingAmountAlign">
                              <div>
                                <p className="m-0 detailsAmountText">Price</p>
                              </div>
                              <div className="detailsAmountText detailsPriceText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                  stripePlans?.currency?.value
                                ) : (
                                  <Currency
                                    currency={
                                      stripePlans?.currency?.value || ""
                                    }
                                  />
                                )}{" "}
                                <CurrencyFormat
                                  currency={stripePlans?.currency?.value}
                                  value={parseFloat(cartAmount?.price)}
                                  decimal={2}
                                />
                                {isOverrideProduct &&
                                  " x " + selectedQuantity?.value}
                              </div>
                            </div>

                            <div className="followingAmountAlign">
                              <div className="followingicon detailsAmountText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ||
                                  (paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO &&
                                    (parseInt(stripeType) ===
                                      SUBSCRIPTION_MODULE_TYPE.FUNDS ||
                                      parseInt(stripeType) ===
                                      SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS ||
                                      parseInt(stripeType) ===
                                      SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL)) ||
                                  (stripePlans?.goldProductType?.value ===
                                    PRODUCT_GOLD_TYPE.KILOGRAM &&
                                    paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER)
                                  ? `Amount ${stripePlans?.goldProductType?.value ===
                                    PRODUCT_GOLD_TYPE.HEDGEKILOGRAM
                                    ? "to be hedged"
                                    : ""
                                  }`
                                  : "Sending amount"}
                                <div
                                  onClick={() =>
                                    handleClickInfo(
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                        ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                                        : paymentMethodSelection ===
                                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                          ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                                          : paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                            ? I_POP_OVER.STRIPE_AMOUNT
                                            : null
                                    )
                                  }
                                >
                                  <img
                                    src="assets/img/InfoIcon.png"
                                    className="infoIconImage"
                                    alt="info"
                                  />
                                </div>
                              </div>
                              <div className="detailsAmountText detailsPriceText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                  getValues("currency")?.value
                                ) : (
                                  <Currency
                                    currency={
                                      getValues("currency")?.value || ""
                                    }
                                  />
                                )}{" "}
                                <CurrencyFormat
                                  currency={getValues("currency")}
                                  value={
                                    getValues("baseAmountRate")
                                      ? parseFloat(getValues("baseAmountRate"))
                                      : "0"
                                  }
                                  decimal={
                                    paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                      ? 6
                                      : 2
                                  }
                                />
                              </div>
                            </div>

                            <div className="followingAmountAlign">
                              <div className="followingicon detailsAmountText">
                                {stripePlans?.goldProductType?.value ===
                                  PRODUCT_GOLD_TYPE.KILOGRAM &&
                                  paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                  ? "Storage fee"
                                  : `Transaction fee ${cartAmount?.charges}%`}
                                <div
                                  onClick={() =>
                                    handleClickInfo(
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                        ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                                        : paymentMethodSelection ===
                                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                          ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                                          : paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                            ? I_POP_OVER.STRIPE_TRANSACTION_FEES
                                            : null
                                    )
                                  }
                                >
                                  <img
                                    src="assets/img/InfoIcon.png"
                                    className="infoIconImage"
                                    alt="info"
                                  />
                                </div>
                              </div>
                              {paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ||
                                paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ? (
                                paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ||
                                  (stripePlans?.goldProductType?.value ===
                                    PRODUCT_GOLD_TYPE.KILOGRAM &&
                                    paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER) ? (
                                  <div className="detailsAmountText detailsPriceText">
                                    {paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                      getValues("currency")?.value
                                    ) : (
                                      <Currency
                                        currency={
                                          getValues("currency")?.value || ""
                                        }
                                      />
                                    )}{" "}
                                    <CurrencyFormat
                                      currency={getValues("currency")}
                                      value={parseFloat(
                                        getValues("transactionFee")
                                      )}
                                      decimal={
                                        paymentMethodSelection ===
                                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                          ? 6
                                          : 2
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div className="detailsAmountText">
                                    Included
                                  </div>
                                )
                              ) : (
                                <div className="detailsAmountText detailsPriceText">
                                  {paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                    getValues("currency")?.value
                                  ) : (
                                    <Currency
                                      currency={
                                        getValues("currency")?.value || ""
                                      }
                                    />
                                  )}{" "}
                                  <CurrencyFormat
                                    currency={getValues("currency")}
                                    value={parseFloat(
                                      getValues("transactionFee")
                                    )}
                                    decimal={
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? 6
                                        : 2
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <hr
                              className="dootedHrLine"
                              style={{ marginBottom: "8px", marginTop: "0px" }}
                            />
                            <div className="followingAmountAlign">
                              <div>
                                <p className="m-0 detailsTotslAmountText">
                                  Total
                                </p>
                              </div>
                              <div className="detailsTotslAmountText detailsPriceText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                  getValues("currency")?.value
                                ) : (
                                  <Currency
                                    currency={
                                      getValues("currency")?.value || ""
                                    }
                                  />
                                )}{" "}
                                <CurrencyFormat
                                  currency={getValues("currency")}
                                  value={parseFloat(getValues("amount"))}
                                  decimal={
                                    paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                      ? 6
                                      : 2
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {selectedStep === 4 && <PaymentStatus />}
              {selectedStep !== 4 && !isTripleaUrl && (
                <div className="container">
                  <div className="row">
                    <div className="col-4">
                      <div
                        onClick={() => handleStep(1)}
                        className="gobackButton"
                      >
                        <p className="m-0">Go back</p>
                      </div>
                    </div>
                    {selectedStep === 2 &&
                      paymentMethodSelection ===
                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD &&
                      selectedCard ? (
                      <div className="col-8">
                        <button
                          type="button"
                          onClick={() =>
                            forwardPaymentPage(
                              SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                            )
                          }
                          disabled={
                            selectedStep === 2 && !selectedCard ? true : false
                          }
                          className="gobackButton continueButton"
                        >
                          <p className="m-0">Continue</p>
                        </button>
                      </div>
                    ) : (
                      selectedStep !== 2 && (
                        <div className="col-8">
                          <button
                            type="button"
                            onClick={() => {
                              if (selectedStep === 3) {
                                handleSubmit(onSubmit(getValues()));
                              } else {
                                if (
                                  parseInt(stripeType) ===
                                  SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL ||
                                  parseInt(stripeType) ===
                                  SUBSCRIPTION_MODULE_TYPE.FUNDS ||
                                  parseInt(stripeType) ===
                                  SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS
                                ) {
                                  if (
                                    !errors.baseAmountRate &&
                                    getValues("baseAmountRate") >= 100
                                  ) {
                                    dispatch(setPaymentSteps(2));
                                    dispatch(selectedCardFunc(null));
                                  }
                                } else {
                                  dispatch(setPaymentSteps(2));
                                  dispatch(selectedCardFunc(null));
                                }
                              }
                            }}
                            disabled={
                              selectedStep === 3 &&
                                (amountWatch <= 0 || ((parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS ||
                                  parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.COMPANYFUNDS) && cryptoAmountWatch < 100) || loader) || getValues("baseAmountRate") <= 0
                                ? true
                                : false
                            }
                            className="gobackButton continueButton"
                          >
                            {loader && (
                              <i className="animateSpin fa-solid fa-circle-notch"></i>
                            )}
                            <p className="m-0">
                              {selectedStep !== 3 ? (
                                "Continue"
                              ) : paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ? (
                                <>
                                  Pay{" "}
                                  <Currency
                                    currency={
                                      getValues("currency")?.value || ""
                                    }
                                  />
                                  <CurrencyFormat
                                    currency={getValues("currency")}
                                    value={parseFloat(getValues("amount"))}
                                    decimal={
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? 6
                                        : 2
                                    }
                                  />
                                </>
                              ) : paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                "Pay now"
                              ) : (
                                "Complete"
                              )}
                            </p>
                          </button>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
              {selectedStep === 4 && (
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        onClick={() =>
                          navigate(RoutesPaths.PAYMENT, {
                            state: { formData: 0, forceUpdate: true },
                          })
                        }
                        className="gobackButton continueButton"
                      >
                        <p className="m-0">View all transactions</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>

      <InfoModalStatic
        infoModalStaticShow={infoModalStaicShow}
        infoModalStaticClose={() => setInfoModalStaticShow(false)}
        infoModalStaicShowType={infoModalStaicShowType}
      />
    </>
  );
}
